import 'vidstack/player/styles/default/theme.css'
import 'vidstack/player'
import 'vidstack/player/ui'

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import './assets/main.css'
import VueApexCharts from 'vue3-apexcharts' // For donut charts
import { installAuth } from './auth/auth'

async function bootstrap() {
  const app = createApp(App)
  const auth = installAuth(app)

  await auth.init()

  app.use(router)
  app.use(VueApexCharts) // For donut charts
  app.mount('#app')
}

void bootstrap()
